<template>
	<div class="g-flow flex-center">
		<div v-for="(item, i) in node" :key="i" class="item" :class="{'z-crt': i == currentIndex, 'z-err': reject && i == currentIndex}">
			<div class="icon flex-center">
				<i v-if="reject && i == currentIndex" class="tf tf-cross"></i>
				<span v-else-if="i >= currentIndex">{{i + 1}}</span>
				<i v-else class="tf tf-check"></i>
			</div>
			<p>{{item.name}}</p>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			node: Array,
			
			current: {
				type: [String, Number],
				default: 1
			},
			
			reject: [String, Number]
		},
		
		computed: {
			currentIndex() {
				if (this.current == this.node.length) return this.node.length + 1;
				return parseInt(this.reject || this.current) - 1;
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.g-flow {
		display: block;
		padding: .3rem 0 .4rem;
		margin-top: 0;
		overflow: auto;
		font-size: 0;
		white-space: nowrap;
		background: #fff;
		
		.item {
			display: inline-block;
			position: relative;
			width: .64rem;
			padding: 0 .9rem .5rem;
			
			elder({
				padding: 0 1.1rem .5rem
			})
			
			&:nth-child(n+2) {
				&:before {
					content: '';
					position: absolute;
					right: 1.54rem;
					top: .3rem;
					width: 1.8rem;
					height: .04rem;
					background: #1492FF;
					
					elder({
						right: 1.74rem,
						width: 2.2rem
					})
				}
			}
			
			&.z-crt {
				~ .item {
					&:before {
						background: #ccc;
					}
					
					.icon {
						border-color: #ccc;
						color: #999;
					}
					
					p {
						color: #666;
					}
				}
				
				.icon {
					border-color: #1492FF;
					color: #fff;
					background: #1492FF;
				}
				
				p {
					font-weight: bold;
					color: #000;
				}
			}
			
			&.z-err {
				&:before {
					background: #E63633;
				}
				
				.icon {
					border-color: #E63633;
					color: #E63633;
					background: #fff;
				}
				
				p {
					font-weight: normal;
					color: #E63633;
				}
			}
			
			.icon {
				box-sizing: border-box;
				height: .64rem;
				border: .04rem solid #1492FF;
				border-radius: 100%;
				font-size: .3rem;
				color: #1492FF;
				background: #fff;
				
				.tf {
					font-size: .28rem;
				}
			}
			
			p {
				position: absolute;
				left: 50%;
				top: .84rem;
				font-size: .28rem;
				white-space: nowrap;
				color: #020202;
				transform: translate(-50%,0);
				
				elder({
					font-size: .36rem
				})
			}
		}
	}
</style>
